const html = require("./html/asnDetailRowReviewView.html");
import {setElementsFromScope, insertTextAndClean, swapClassesViaBool, show, hide, handleDisplayFor, boolToHuman, setCheckboxState, enableInput, disableInput, setRequired, setUniqNames, setDisabled} from "../../../utilities/selectorHelpers";
import _ from "underscore";
import $ from "jquery";
import AsnDetailStore from "../../../stores/AsnDetailStore";


const elementsMap = {
  asnDetailLength: ".asn-detail-length",
  asnDetailWidth: ".asn-detail-width",
  asnDetailHeight: ".asn-detail-height",
  asnDetailWeight: ".asn-detail-weight",
  palletCaseIdx: ".pallet-case-idx",
  palletCaseLabel: ".pallet-case-label",
  stackablePalletOuter: ".stackable-pallet-outer",
  stackablePalletVal: ".stackable-pallet-val"
};

const yesClassName = "q-ppt-purple";
const noClassName = "q-ppt-grey";

export default function AsnDetailRowReviewView(asnDetail, 
  options){
  const asnDetailId = asnDetail.id;

  const {rowIdx, isPallet} = options;

  const self = this;
  self._element = $();
  const els = {};

  self.init = function(){
    render();
  };

  function bindElements(){

  }




  function bindStores(){
    AsnDetailStore.bindListener(`asn_details:change:${asnDetailId}`, updateSelf);
  }

  self.unbindListeners = function(){
    AsnDetailStore.unbindListener(`asn_details:change:${asnDetailId}`, updateSelf);
  };

  function setWidgets(){

  }

  function setElements(){
    setElementsFromScope(els, elementsMap, self._element);
  }

  self.getElement = function(){
    return self._element;
  }


  function update(){
    // handle rendering children
    updateSelf();
  }

  function updateSelf(){
    // handle updating values;
    updateValues();
    updatePalletCaseIdx();
    updatePalletCaseLabel();
    updatePalletSpecificFields();
  }

  function updatePalletSpecificFields(){
    const isPlt = isPallet();
    const asnDetail = getAsnDetail();
    handleDisplayFor(els.stackablePalletOuter, isPlt);
    if(isPlt){
      swapClassesViaBool(els.stackablePalletVal, yesClassName, noClassName, asnDetail.stackablePallet);
    }
  }

  function updateValues(){
    const asnDetail = getAsnDetail();
    insertTextAndClean(els.asnDetailLength, asnDetail.asd_package_length);
    insertTextAndClean(els.asnDetailWidth, asnDetail.asd_package_width);
    insertTextAndClean(els.asnDetailHeight, asnDetail.asd_package_height);
    insertTextAndClean(els.asnDetailWeight, asnDetail.asd_package_weight);
    insertTextAndClean(els.stackablePalletVal, boolToHuman(asnDetail.stackablePallet));
  }


  function updatePalletCaseIdx(){
    els.palletCaseIdx.text(rowIdx + 1);
  }


  function updatePalletCaseLabel(){
    let text = "Case";
    if(isPallet()){
      text = "Pallet";
    }
    els.palletCaseLabel.text(text);
  }



  function defaultToOne(numb){
    return (numb || 1);
  }

  function render(){
    self._element = $(html);
    setElements();
    setWidgets();
    bindElements();
    bindStores();
    update();
  }


  function getAsnDetail(){
    return AsnDetailStore.getAsnDetail(asnDetailId);
  }
}


// WEBPACK FOOTER //
// ./src/pages/asns/ReviewTab/AsnDetailRowReviewView.js